import { ShieldCheck } from "lucide-react";

/**
 * Warranty matrix — a premium card grid of {duration, family, note}. Used on /garantie.
 * Content: { title, subtitle, items: [{ months, label, note }] }.
 */
type Item = { months?: string | number; label?: string; note?: string };

export function WarrantyMatrixRenderer({
  component,
}: {
  component: { content?: { title?: string; subtitle?: string; items?: Item[] } };
}) {
  const { title, subtitle, items = [] } = component.content ?? {};
  if (items.length === 0) return null;
  return (
    <section className="mx-auto max-w-6xl px-4 py-10 md:px-8 md:py-14">
      {title ? (
        <div className="mb-8 text-center">
          <h2 className="text-2xl font-bold tracking-tight text-[#0A0A0A] md:text-[2rem]" style={{ fontFamily: "var(--font-aleo)" }}>{title}</h2>
          {subtitle ? <p className="mt-2 text-[#6B7280]">{subtitle}</p> : null}
          <div className="mx-auto mt-3 h-1 w-10 rounded-full bg-[#00B862]" aria-hidden="true" />
        </div>
      ) : null}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((it, i) => (
          <div key={i} className="apa-card apa-card-hover group flex h-full flex-col p-5">
            <span className="grid h-11 w-11 place-items-center rounded-xl bg-[var(--color-forest-100)] text-[var(--color-forest-600)] transition group-hover:bg-[#00B862] group-hover:text-white group-hover:shadow-[var(--shadow-glow)]">
              <ShieldCheck className="h-5 w-5" />
            </span>
            <p className="mt-4 text-3xl font-extrabold text-[#00B862] tabular-nums" style={{ fontFamily: "var(--font-aleo)" }}>
              {it.months}<span className="ml-1 text-base font-bold text-[#121212]">mois</span>
            </p>
            <p className="mt-1 text-sm font-bold text-[#121212]">{it.label}</p>
            {it.note ? <p className="mt-1 text-xs leading-relaxed text-[#6B7280]">{it.note}</p> : null}
          </div>
        ))}
      </div>
    </section>
  );
}
